import { RouteConfig } from "vue-router";
import { metaRequireAuth } from "@/router/meta-constants";
import HomePage from "@/views/home/index.vue";
import ScanTicketPage from "@/views/scan-ticket/index.vue";
import ReportPage from "@/views/report/index.vue";
import AboutPage from "@/views/about/index.vue";
import PrintPage from "@/views/print/index.vue";
import ChangePinPage from "@/views/change-pin/index.vue";
import LotoPage from "@/views/loto/index.vue";
import LotoPageEvents from "@/views/loto/events.vue";
import LotoPageNumber from "@/views/loto/number.vue";
import LotoPage645 from "@/views/loto-645/index.vue";
import LotoPage645Number from "@/views/loto-645/numbers.vue";
import ResultPage from "@/views/result/index.vue";
import SportPage from "@/views/sport/index.vue";
import HistoryPage from "@/views/history/index.vue";
import VoucherPage from "@/views/voucher/index.vue";

const authenticatedRoutes: Array<RouteConfig> = [
    {
        path: "/",
        name: "Home Page",
        meta: {
            ...metaRequireAuth,
            isNotMargin: true,
        },
        component: HomePage,
    },
    {
        path: "/scan-ticket",
        name: "Ticket Detail Page",
        meta: {
            ...metaRequireAuth,
            isShowMenu: true,
        },
        component: ScanTicketPage,
    },
    {
        path: "/report-final",
        name: "Report Final Page",
        component: ReportPage,
        meta: {
            ...metaRequireAuth,
            isFinal: true,
            isShowMenu: true,
        },
    },
    {
        path: "/report",
        name: "Report Page",
        component: ReportPage,
        meta: {
            ...metaRequireAuth,
            isFinal: false,
            isShowMenu: true,
        },
    },
    {
        path: "/about",
        name: "About",
        meta: {
            ...metaRequireAuth,
            isShowMenu: true,
        },
        component: AboutPage,
    },
    {
        path: "/print",
        name: "Print Test Page",
        meta: {
            ...metaRequireAuth,
            isShowMenu: true,
        },
        component: PrintPage,
    },
    {
        path: "/change-pin",
        name: "ChangePin",
        meta: {
            ...metaRequireAuth,
            isShowMenu: true,
        },
        component: ChangePinPage,
    },
    {
        path: "/loto",
        name: "Loto",
        meta: {
            ...metaRequireAuth,
            isShowMenu: true,
        },
        component: LotoPage,
    },
    {
        path: "/loto-events",
        name: "Loto Events",
        meta: {
            ...metaRequireAuth,
            isShowMenu: true,
        },
        component: LotoPageEvents,
    },
    {
        path: "/loto-number",
        name: "Loto number",
        meta: {
            ...metaRequireAuth,
            isShowMenu: true,
        },
        component: LotoPageNumber,
    },
    {
        path: "/loto-645",
        name: "Loto 6/45",
        meta: {
            ...metaRequireAuth,
            isShowMenu: true,
        },
        component: LotoPage645,
    },
    {
        path: "/loto-645/numbers",
        name: "Loto 6/45 numbers",
        meta: {
            ...metaRequireAuth,
            isShowMenu: true,
        },
        component: LotoPage645Number,
    },
    {
        path: "/results",
        name: "Result Page",
        meta: {
            ...metaRequireAuth,
            isShowMenu: true,
        },
        component: ResultPage,
    },
    {
        path: "/sports",
        name: "Sport Pages",
        component: SportPage,
        meta: {
            ...metaRequireAuth,
            isNotPadding: true,
        },
    },
    {
        path: "/history",
        name: "History Page",
        meta: {
            ...metaRequireAuth,
            isShowMenu: true,
        },
        component: HistoryPage,
    },
    {
        path: "/voucher",
        name: "Voucher Page",
        meta: {
            ...metaRequireAuth,
            isShowMenu: true,
        },
        component: VoucherPage,
    },
];

export default authenticatedRoutes;
